<ng-container>
	<img *ngIf="addCloseBtn" class="close-btn" (click)="closeExplanation()" alt="closing help button"
		src="../../assets/img/{{themeService.theme}}/close-btn1.svg">
	<img src="../../../assets/img/{{themeService.theme}}/delegate.svg" alt="Delegate logo" width="138px">
	<h2>About delegates</h2>
	<p>Flexible sharing options allow you to share what you wish, when you wish with those closest to you in life.</p>
	<section class="explanations">
		<div class="rights">
			<div class="div-opacity div-opacity-contributor">
				<i class="fa fas fa-pen-alt contributor-fa"></i>
				<div class="contributor rights-div">Contributor</div>
			</div>
		</div>
		<p>Allows your delegate to view and edit your plan so that they can help you to build and manage it.</p>
		<div class="rights">
			<div class="div-opacity div-opacity-now">
				<i class="fa fas fa-eye viewer-now-fa"></i>
				<div class="viewer-now rights-div">Viewer - Now</div>
			</div>
		</div>
		<p>Allows your delegate to view your plan, without the ability to edit it by themselves.</p>
		<div class="rights">
			<div class="div-opacity div-opacity-future">
				<i class="fa fas fa-eye viewer-future-fa"></i>
				<div class="viewer-future rights-div">Viewer - Future</div>
			</div>
		</div>
		<p>Allows your delegate to view your plan only when you pass away or if you lose mental capacity.</p>
		<div class="rights">
			<div class="div-opacity div-opacity-no-access">
				<i class="fa fas fa-lock no-access-fa"></i>
				<div class="no-access rights-div">No Access</div>
			</div>
		</div>
		<p>Prevents your delegate from accessing your plan at all times.</p>
	</section>
</ng-container>